// extracted by mini-css-extract-plugin
export var bgBlack = "Layout-module--bg-black--230ee";
export var bgBlue = "Layout-module--bg-blue--69151";
export var bgCustomDark = "Layout-module--bg-custom-dark--e0651";
export var bgEvergreenDeep = "Layout-module--bg-evergreen-deep--89249";
export var bgGrey = "Layout-module--bg-grey--ce050";
export var layoutBody = "Layout-module--layout-body--05aa8";
export var page = "Layout-module--page--8ac51";